import { forwardRef, useEffect, useMemo } from 'react'
import { compareTime } from '../utils'
import { Button } from 'shared/Button'
import { useCompactTimeFormatter } from '../hooks'

type DateInputTimePickerProps = {
  value: Date
  pickerDates: Date[]
  onChange: (value: Date) => void
}
export const DateInputTimePicker = forwardRef<HTMLDivElement, DateInputTimePickerProps>(
  ({ value, pickerDates, onChange }, elRef) => {
    const selectedTimeIndex = useMemo(() => {
      return pickerDates.findIndex((d) => compareTime(d, value))
    }, [pickerDates, value])

    const compactTimeFormatter = useCompactTimeFormatter()

    useEffect(() => {
      pickerDates[selectedTimeIndex] && onChange(pickerDates[selectedTimeIndex])
    }, [pickerDates, onChange, selectedTimeIndex])

    return (
      <div className="DateInput__content__time-picker" ref={elRef}>
        {pickerDates.map((d, index) => {
          return (
            <Button
              appearance="menu-item"
              key={d.getTime()}
              className={selectedTimeIndex === index ? 'menu-button selected' : 'menu-button'}
              onClick={() => onChange(d)}
            >
              {compactTimeFormatter.format(d)}
            </Button>
          )
        })}
      </div>
    )
  }
)
